import axios from "axios";

const API_BASE_URL =
    process.env.REACT_APP_API_URL ||
    (typeof window !== "undefined" && window._env_?.REACT_APP_API_URL) ||
    "http://localhost:3000/sweetmedical/v1";

const axiosClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosClient.interceptors.request.use((config) => {
    const storedAuth = localStorage.getItem("sweetMedicalAuth");
    if (storedAuth) {
        const { token } = JSON.parse(storedAuth);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});

const handleRequest = async (request) => {
    try {
        const response = await request();
        return response.data;
    } catch (error) {
        const message =
            error.response?.data?.error ||
            error.response?.data?.message ||
            error.message ||
            "No se pudo conectar con el servidor";

        throw new Error(message);
    }
};

export const apiClient = {
    get: (path, config = {}) => {
        return handleRequest(() => axiosClient.get(path, config));
    },

    post: (path, data, config = {}) => {
        return handleRequest(() => axiosClient.post(path, data, config));
    },

    patch: (path, data, config = {}) => {
        return handleRequest(() => axiosClient.patch(path, data, config));
    },

    put: (path, data, config = {}) => {
        return handleRequest(() => axiosClient.put(path, data, config));
    },

    delete: (path, config = {}) => {
        return handleRequest(() => axiosClient.delete(path, config));
    },
};